<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-7">
				<sf-card class="p-0 h-100 card_bg">
					<search-view
						ref="searchView"
						@Refresh="refresh"
						:scrId="scrId"
						:flgOsGrp="this.flgOsGrp"
						:flgPqyapGrp="this.flgPqyapGrp"
						:flgPqyrvGrp="this.flgPqyrvGrp"
						:flgPqyrgGrp="this.flgPqyrgGrp"
					></search-view>
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-view
						ref="tableView"
						@Refresh="refresh"
						:scrId="scrId"
						:flgOsGrp="this.flgOsGrp"
						:flgPqyapGrp="this.flgPqyapGrp"
						:flgPqyrvGrp="this.flgPqyrvGrp"
						:flgPqyrgGrp="this.flgPqyrgGrp"
						@OpenPopup="openPopup"
					></table-view>
				</sf-card>
			</div>
			<!-- 불량보고서 등록/수정 팝업 -->
			<popup-detail ref="popupRef" @Refresh="refresh2" :scrId="scrId"></popup-detail>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCku/store/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';

import SearchView from './Search/Search';
import TableView from './Table/Table';
import PopupDetail from '@qms/pqy/pcku/PrtRpt/Content/Popup/Popup'; //불량보고서 등록/수정 팝업
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			flgOsGrp: false, //시스템관리자
			flgPqyapGrp: false, //관리자(승인)
			flgPqyrvGrp: false, //중간관리자(검토)
			flgPqyrgGrp: false //업무담당자(작성)
		};
	},
	async created() {
		this.screen = this.screenArray.get(this.scrId);
		this.getOs(); // 시스템 총괄그룹
		this.getPqyap(); //승인자그룹
		this.getPqyrv(); //검토자그룹
		this.getPqyrg(); //작성자그룹
	},
	components: { SearchView, TableView, PopupDetail },
	computed: {
		...rootComputed,
		...serviceComputed,
		...qmsComputed
	},

	methods: {
		...rootMethods,
		...serviceMethods,
		...qmsMethods,
		refresh() {
			this.$refs.searchView.searchList();
		},
		refresh2() {
			this.$refs.searchView.searchList();
		},
		openPopup(params, gbn) {
			this.$refs.popupRef.open(params, gbn);
		},
		async getOs() {
			this.flgOsGrp = await this.inclUsrGrp_('OS'); //시스템 관리자
		},
		async getPqyap() {
			this.flgPqyapGrp = await this.inclUsrGrp_('PQYAP'); //생산품질 관리자(승인)
		},
		async getPqyrv() {
			this.flgPqyrvGrp = await this.inclUsrGrp_('PQYRV'); //생산품질 중간관리자(검토)
		},
		async getPqyrg() {
			this.flgPqyrgGrp = await this.inclUsrGrp_('PQYRG'); //생산품질 일반사용자(작성)
		}
	}
};
</script>

<style></style>
